export class Visit {
  id: string = null;
  date: string = null;
  visitDate: string = null;
  time: string = null;
  hoursread: number = null;
  prevhoursread: number = null;
  requestType: string = null;
  orderNumber: number = null;
  orderHour: number = null;
  prevOrderHour: number = null;
  actions: any = null;
  catalog: any = null;
  troubleshooting: any = null;
  notes: string = null;
  start: string = null;
  end: string = null;
  supervisor: string = null;
  generatorNumber: string = null;
  reviewed: boolean = false;
  accountId: string = null;
  reviewerId: string = null;
  powertrainId: string = null;
  motorId: string = null;
  workshopId: string = null;
  orderGeneratedDate: string = null;
  orderDone: boolean = null;
  orderDoneReviewed: boolean = null;
  orderDoneReviewedBy: string = null;
  orderDoneBy: string = null;
  visitId: string = null;
  isOrderGeneratedFromVisit: boolean = null;
  reminder: number = null;
  created: Date = null;
  updated: Date = null;

  reset() {
    this.id = null;
    this.date = null;
    this.time = null;
    this.hoursread = null;
    this.prevhoursread = null;
    this.requestType = null;
    this.orderNumber = null;
    this.orderHour = null;
    this.prevOrderHour = null;
    this.actions = null;
    this.catalog = null;
    this.troubleshooting = null;
    this.notes = null;
    this.start = null;
    this.end = null;
    this.supervisor = null;
    this.generatorNumber = null;
    this.reviewed = false;
    this.accountId = null;
    this.reviewerId = null;
    this.powertrainId = null;
    this.motorId = null;
    this.workshopId = null;
    this.orderGeneratedDate = null;
    this.orderDone = null;
    this.orderDoneReviewed = null;
    this.orderDoneReviewedBy = null;
    this.orderDoneBy = null;
    this.visitId = null;
    this.isOrderGeneratedFromVisit = null;
    this.reminder = null;
    this.created = null;
    this.updated = null;
  }
}
